import React, { useState } from "react";
import "./IVFSteps.css";
import fertilization1 from "../assets/fertilization1.png";
import fertilization2 from "../assets/fertilization2.png";
import fertilization3 from "../assets/fertilization3.png";
import fertilization4 from "../assets/fertilization4.png";
import { useTranslation } from "react-i18next";

const IVFSteps = () => {
    const { t } = useTranslation();
    const [currentStep, setCurrentStep] = useState(1);

    const steps = [
        {
            title: t("IVFTitle1"),
            description: t("IVFText1"),
            imgSrc: fertilization1,
        },
        {
            title: t("IVFTitle2"),
            description: t("IVFText2"),
            imgSrc: fertilization2,
        },
        {
            title: t("IVFTitle3"),
            description: t("IVFText3"),
            imgSrc: fertilization3,
        },
        {
            title: t("IVFTitle4"),
            description: t("IVFText4"),
            imgSrc: fertilization4,
        },
    ];

    return (
        <div className="horizontal-ivf-steps">
            <h1 className="ivf-title">{t("IVFHead")}</h1>
            <p className="ivf-description">{t("IVFDesc")}</p>

            <div className="steps-container">
                {steps.map((step, index) => (
                    <div
                        key={index}
                        className={`step-item ${
                            currentStep === index + 1 ? "active-step" : ""
                        }`}
                        onClick={() => setCurrentStep(index + 1)}
                    >
                        <div className="step-indicator">{index + 1}</div>
                        <h3 className="step-title">{step.title}</h3>
                    </div>
                ))}
            </div>

            <div className="step-details">
                <img
                    src={steps[currentStep - 1].imgSrc}
                    alt={`Step ${currentStep} Illustration`}
                    className="step-illustration"
                />
                <div className="step-text">
                    <h2>{steps[currentStep - 1].title}</h2>
                    <p>{steps[currentStep - 1].description}</p>
                </div>
            </div>
        </div>
    );
};

export default IVFSteps;
